import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import $ from 'jquery';

const DetailScratcher = ({ scratcher, decDetailPos, incDetailPos, changeView, previousView, view }) =>  {

    function changeDetail(direction, slug){
        // scroll up
        $('.scene').scrollTop(0);

        // dispatch action
        if (direction === 'inc') {
            incDetailPos(slug);
        } else {
            decDetailPos(slug);
        }
    }

  return (
    <div className="scene__content-right">
        <svg className="tickets" version="1.1" x="0px" y="0px" viewBox="0 0 793.3 819.9" style={{enableBackground:'new 0 0 793.3 819.9'}}>
            <image x={scratcher.x} y={scratcher.y} xlinkHref={scratcher.image} width={scratcher.width} height={scratcher.height} filter="url(#ticket-shadow)" />
        </svg>

        <a className="close" onClick={() => changeView(previousView, view)}>
            <svg className="icon" viewBox="0 0 18 18">
                <use xlinkHref="#icon-close"></use>
            </svg>
        </a>
        <a className="ticket-nav ticket-nav--left" onClick={() => changeDetail('dec', scratcher.slug)}>
            <svg className="icon" viewBox="0 0 18 18">
                <use xlinkHref="#icon-chevron-left"></use>
            </svg>
        </a>
        <a className="ticket-nav ticket-nav--right" onClick={() => changeDetail('inc', scratcher.slug)}>
            <svg className="icon" viewBox="0 0 18 18">
                <use xlinkHref="#icon-chevron-right"></use>
            </svg>
        </a>
    </div>
  );
}

export default DetailScratcher;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Detail/DetailScratcher.js
 **/